/** @format */

export const homeSchema = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'Organization',
			'@id': 'https://www.llb360.com/#organization',
			name: 'LLB360',
			url: 'https://www.llb360.com',
			logo: {
				'@type': 'ImageObject',
				url: 'https://www.llb360.com/logo.png',
			},
			sameAs: [
				'https://www.instagram.com/llb360',
				'https://www.linkedin.com/company/llb360',
				'https://www.facebook.com/llb360',
			],
		},
		{
			'@type': 'WebSite',
			'@id': 'https://www.llb360.com/#website',
			url: 'https://www.llb360.com',
			name: 'LLB360',
			description:
				'LLB360 provides structured LLB exam notes, repeated questions, landmark cases, and exam-oriented legal study material.',
			publisher: {
				'@id': 'https://www.llb360.com/#organization',
			},
			potentialAction: {
				'@type': 'SearchAction',
				target: 'https://www.llb360.com/search?q={search_term_string}',
				'query-input': 'required name=search_term_string',
			},
		},
	],
};
